import React from 'react';
import './story-shimmer.m.css';

const StoryPageShimmer = () => (
  <div styleName="story-page-shimmer" className="container">
    {/* <div styleName="shimmer-container">
      <div styleName="shimmer"></div>
    </div> */}
    <div styleName="card">
      <div styleName="shimmerBG media"></div>
      <div styleName="p-32">
        <div styleName="shimmerBG title-line"></div>
        <div styleName="shimmerBG title-line end"></div>

        <div styleName="shimmerBG content-line m-t-24"></div>
        <div styleName="shimmerBG content-line"></div>
        <div styleName="shimmerBG content-line"></div>
        <div styleName="shimmerBG content-line"></div>
        <div styleName="shimmerBG content-line end"></div>
      </div>
    </div>
  </div>
);

export default StoryPageShimmer;
